import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { ContactForm } from './Contacts/ContactForm';

export class EditContact extends Component {
    static displayName = EditContact.name;

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <h1>Edit Contact</h1>

                <ContactForm type="edit" />
            </div>
        );
    }
}
